import { render, staticRenderFns } from "./consignments-by-months.vue?vue&type=template&id=04eaf09c&scoped=true&"
import script from "./consignments-by-months.vue?vue&type=script&lang=js&"
export * from "./consignments-by-months.vue?vue&type=script&lang=js&"
import style0 from "./consignments-by-months.vue?vue&type=style&index=0&id=04eaf09c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eaf09c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VProgressLinear,VRow,VSelect,VSimpleTable})
